import _ from 'lodash';

const formatNumber = ({ id, number, country }) => ({
  value: id,
  label: `${country} ${number}`,
  className: 'conference-number-dropdown-item',
});

export const selectNumbersByCountries = ({ countries }) => {
  const groups = _.groupBy(countries, 'country');
  return _.map(groups, (numbers, groupName) => {
    const formattedNumbers = _.map(numbers, formatNumber);
    return { type: 'group', name: groupName, items: formattedNumbers };
  });
};



// WEBPACK FOOTER //
// ./redux/selectors/countries.js